import { ReactNode, useRef } from "react";
import styled, { css } from "styled-components";
import { SMALL_DESKTOP_BREAKPOINT } from "../../styles/breakpoints";
import { hexWithOpacity } from "../../utils/hexWithOpacity";

type Props = {
  children: ReactNode;
  customContentStyles?: ReturnType<typeof css>;
  handleClose?: () => void;
  className?: string;
};
export const ModalContainer = ({
  children,
  customContentStyles,
  handleClose,
  className,
}: Props) => {
  const overlayRef = useRef<HTMLDivElement>(null);

  const handleOverlayClick = (event: React.MouseEvent<HTMLDivElement>) => {
    if (overlayRef.current && event.target === overlayRef.current) {
      handleClose?.();
    }
  };

  return (
    <ModalOverlay ref={overlayRef} onClick={handleOverlayClick}>
      <ModalContent $customStyles={customContentStyles} className={className}>
        {children}
      </ModalContent>
    </ModalOverlay>
  );
};

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: ${({ theme }) => hexWithOpacity(theme.colors.black, 0.5)};
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 102;
`;

const ModalContent = styled.div<{ $customStyles?: ReturnType<typeof css> }>`
  background-color: ${({ theme }) => theme.colors.background};
  padding: 30px 30px 10px 30px;
  border-radius: 20px;
  position: relative;
  display: flex;
  flex-direction: column;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
  @media (max-width: ${SMALL_DESKTOP_BREAKPOINT}) {
    width: 100%;
    height: 100%;
    border-radius: 0;
  }
  ${({ $customStyles }) => $customStyles}
`;
